import { render } from "./BaseButtonRounded.vue?vue&type=template&id=8a32a0ce"
import script from "./BaseButtonRounded.vue?vue&type=script&lang=js"
export * from "./BaseButtonRounded.vue?vue&type=script&lang=js"

import "./BaseButtonRounded.vue?vue&type=style&index=0&id=8a32a0ce&lang=scss"

import exportComponent from "/home/s-ol/dot/multi/multi-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__